/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
	connectedCallback() {
		this.querySelectorAll('table').forEach(this.#formatTable);
		this.#formatSources();
	}

	/**
	 * Transforms a "Sources" H2 + all following siblings (until next H2) into a styled accordion.
	 * Works whether the sources are in an <ol>, or plain numbered paragraphs.
	 */
	#formatSources() {
		this.querySelectorAll('h2').forEach((h2) => {
			if (h2.textContent.trim() !== 'Sources') return;

			// Collect all siblings after this h2 until the next h2 or end
			const contentNodes = [];
			let next = h2.nextElementSibling;
			while (next && next.tagName !== 'H2') {
				contentNodes.push(next);
				next = next.nextElementSibling;
			}

			if (contentNodes.length === 0) return;

			const wrapper = document.createElement('accordion-custom');

			const details = document.createElement('details');
			details.className = 'details sources-accordion';

			const summary = document.createElement('summary');
			summary.className = 'details__header';
			summary.textContent = 'Sources';

			const caretSpan = document.createElement('span');
			caretSpan.className = 'svg-wrapper icon-caret icon-animated';
			caretSpan.innerHTML =
				'<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
			summary.appendChild(caretSpan);

			const content = document.createElement('div');
			content.className = 'details-content';
			contentNodes.forEach((node) => content.appendChild(node.cloneNode(true)));

			details.appendChild(summary);
			details.appendChild(content);
			wrapper.appendChild(details);

			h2.replaceWith(wrapper);
			contentNodes.forEach((node) => node.remove());
		});
	}

	/**
	 * Formats a table for easier styling
	 * @param {HTMLTableElement} table
	 */
	#formatTable(table) {
		const wrapper = document.createElement('div');
		wrapper.classList.add('rte-table-wrapper');
		const parent = table.parentNode;
		if (parent) {
			parent.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		}
	}
}

if (!customElements.get('rte-formatter')) {
	customElements.define('rte-formatter', RTEFormatter);
}
